import React, { useState } from 'react'
import classNames from 'classnames'
import UploadProfileImage from './UploadProfile';
import RenderProfilePicture from '../../../../_helpers/profile-picture';
import { Card, Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap'

import './style.css'
import SpecialtiesOption from '../../../../_components/Options/SpecialtiesOption';
import RolesOptions from '../../../../_components/Options/RolesOptions';

export default function UserForm({
    edit = false,
    state,
    errors,
    setParentState, 
    password,
    userType,
    profileImage,
    setPassword, 
    currentlyFocused,
    toggleRoleDetails,
    handleSetShowPassword,
    togglePasswordChecklist,
    children
  }) {
  const [showPassword, setShowPassword] = useState(false)  

  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleSetPassword = () => {
    const clearPassword = setPassword ? null : password
    setParentState({ password: clearPassword })
    handleSetShowPassword(!setPassword)
  }

  const renderErrorMessage = (value) => {
    return errors[value] && <small className="text-danger">
      {errors[value]}
    </small>
  }

  const eyeIconClass = classNames('far cursor-pointer', {
    'fa-eye': !showPassword,
    'fa-eye-slash': showPassword
  })

  return (
    <Card id="UserForm" className='border-0 axs-shadow axs-rounded'>
      <Card.Body>
        <Row>
          <Col xs='4'>
            <label><span className="text-danger">*</span> Name</label>
          </Col>
          <Col>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Control 
                    value={state.firstName}
                    type="text" 
                    name="firstName"
                    onBlur={() => currentlyFocused('')}
                    onFocus={() => currentlyFocused('firstName')} 
                    onChange={(e) => setParentState({firstName: e.target.value})} 
                    placeholder="Enter First Name" 
                    className={errors.firstName && 'is-invalid'}
                  />
                  {renderErrorMessage('firstName')}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Control 
                    value={state.lastName}
                    type="text" 
                    name='lastName'
                    onBlur={() => currentlyFocused('')}
                    onFocus={() => currentlyFocused('lastName')} 
                    onChange={(e) => setParentState({lastName: e.target.value})} 
                    placeholder="Enter Last Name" 
                    className={errors.lastName && 'is-invalid'}
                  />
                  {renderErrorMessage('lastName')}
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs='4'>Credentials</Col>
          <Col xs='4'>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Control 
                    value={state.credentials}
                    type="text" 
                    name='credentials'
                    onBlur={() => currentlyFocused('')}
                    onFocus={() => currentlyFocused('credentials')} 
                    onChange={(e) => setParentState({credentials: e.target.value})} 
                    placeholder="Ex: R.N., MSN" 
                    className={errors.credentials && 'is-invalid'}
                  />
                  {renderErrorMessage('credentials')}
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr />
        {userType === 'Staff' ?
          <Row>
            <Col xs='4'>Title</Col>
            <Col xs='4'>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Control 
                      defaultValue={state.specialtyTitle}
                      value={state.title}
                      type="text" 
                      name='title'
                      onBlur={() => currentlyFocused('')}
                      onFocus={() => currentlyFocused('title')} 
                      onChange={(e) => setParentState({title: e.target.value})}
                      placeholder="Ex: Scheduler, Manager" 
                      className={errors.title && 'is-invalid'}
                    />
                    {renderErrorMessage('title')}
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
          :
          <Row 
            onMouseLeave={() => currentlyFocused('')}
            onMouseOver={() => currentlyFocused('specialty')} 
          >
            <Col xs='4'>
              <label><span className="text-danger">*</span> Specialty</label>
            </Col>
            <Col xs='4' name='specialty'>
              <Form.Group>
                <SpecialtiesOption
                  defaultValue={state.specialtyTitle}
                  invalid={errors.specialtyId}
                  handleSelected={selected => {
                    if (selected) {
                      setParentState({ specialtyId: selected.value })
                    } else {
                      setParentState({ specialtyId: null })
                    }
                  }}
                />
                {renderErrorMessage('specialtyId')}
              </Form.Group>
            </Col>
          </Row>
        }

        <hr />
        <Row 
          onMouseLeave={() => currentlyFocused('')}
          onMouseOver={() => currentlyFocused('profileImage')} 
        >
          <Col xs='4'>Profile Image</Col>
          <Col xs='6'>
            <Row name='profileImage'>
              <Col xs='auto' className='my-auto'>
                <RenderProfilePicture 
                  circle 
                  image={profileImage ? profileImage : "https://s3.amazonaws.com/axs.images/assets/profile5.png"} 
                  width={45} 
                  height={45} 
                  cached={false} 
                  className='m-auto' 
                />
              </Col>
              <Col>
                <UploadProfileImage handleUpload={base64Img => {                  
                  setParentState({
                    profileImage: base64Img
                  })
                }}/>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs='4'>
            <label><span className="text-danger">*</span> Role</label>
          </Col>
          <Col xs='4'>
            <Form.Group name='role'>
              <RolesOptions
                defaultValue={state.role}
                invalid={errors.roleId}
                handleSelected={(selected) => {
                  if (selected) {
                    setParentState({ roleId: selected.value })
                  } else {
                    setParentState({ roleId: null })
                  }
                }}
                onBlur={() => toggleRoleDetails('')}
                onFocus={() => toggleRoleDetails('role')} 
              />
              {renderErrorMessage('roleId')}
            </Form.Group>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs='4'>
            <Row>
              <Col>
                <label><span className="text-danger">*</span> Username</label>
              </Col>
            </Row>
            <Row className='pt-2'>
              <Col className='text-muted font-weight-light'>
                The username must be an email address
              </Col>
            </Row>
          </Col>
          <Col xs='4' className='my-auto'>
            <InputGroup>
              <InputGroup.Prepend className='border-right-0'>
                <InputGroup.Text 
                  type="email"
                  id="username-addon1" 
                  className='pr-0' 
                  style={{background: 'white', border: errors.username ? '1px solid red' : ''}}
                >
                  <i className="far fa-envelope" style={{color: 'RGB(201, 201, 201)'}}></i>
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                value={state.username}
                name='username'
                type="email"
                className={`border-left-0 ${errors.username && 'is-invalid'}`}
                aria-label="email"
                placeholder="Enter Username"
                aria-describedby="username-addon1"
                onChange={(e) => setParentState({username: e.target.value})}
              />
            </InputGroup>
            {renderErrorMessage('username')}
          </Col>
        </Row>

        { !edit &&
          <>
            <hr />
            <Row>
              <Col xs='4'>
                <Row>
                  <Col>
                    Set Password
                  </Col>
                </Row>
                <Row className='pt-2'>
                  <Col className='text-muted font-weight-light'>
                    Allow the user to set their own password or set a password for them
                  </Col>
                </Row>
              </Col>
              <Col xs='4' className='my-auto'>
                <div className="form-group">
                  <div className="custom-control custom-switch">
                    <input 
                      id="set-password-switch" 
                      type="checkbox" 
                      checked={setPassword}
                      onChange={handleSetPassword}
                      className="custom-control-input" 
                    />
                    <label className="custom-control-label" htmlFor="set-password-switch">Set Password</label>
                  </div>
                </div>
              </Col>
              {setPassword && <Col xs='4'>
                  <InputGroup>
                    <Form.Control 
                      name="password"
                      type={showPassword ? "text" : "password" }
                      onBlur={() => togglePasswordChecklist(false)}
                      onFocus={() => togglePasswordChecklist(true)} 
                      onChange={(e) => setParentState({password: e.target.value})}
                      className={`border-right-0 ${errors.password && 'is-invalid'}`} 
                      aria-label="password"
                      placeholder="Enter Password" 
                      aria-describedby="password-addon2"
                    />
                    <InputGroup.Append className={`border-left-0`} >
                      <InputGroup.Text id="password-addon2" className='pl-0' style={{background: 'white', border: errors.password ? '1px solid red' : ''}}>
                        <i onClick={toggleShowPassword} className={eyeIconClass}></i>
                      </InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
                  {renderErrorMessage('password')}
                </Col>
              }
            </Row>
          </>
        }

        { userType === 'Staff' && 
          <>
            <hr />
            <Row 
              onMouseOver={() => currentlyFocused('identity')}
              onMouseLeave={() => currentlyFocused('')}
            >
              <Col xs='4'>
                <Row>
                  <Col>
                    Public Identity
                  </Col>
                </Row>
                <Row className='pt-2'>
                  <Col className='text-muted font-weight-light'>
                    Should the user's name be hidden from the patient for privacy concerns
                  </Col>
                </Row>
              </Col>
              <Col id='formIdentity' className='my-auto'>
                <Row className='mb-2'>
                  <Col>
                    <div className="form-check">
                      <label className="form-check-label" >
                        <input 
                          type="radio" 
                          name="identity"
                          checked={state.publicIdentity === true}
                          onChange={() => {
                            setParentState({publicIdentity: true })
                            currentlyFocused('identity')
                          }}
                          className="form-check-input" /> Display Identity
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="form-check">
                      <label className="form-check-label">
                        <input 
                          type="radio" 
                          name="identity" 
                          checked={state.publicIdentity === false}
                          onChange={() => {
                            setParentState({publicIdentity: false })
                            currentlyFocused('identity')
                          }}
                          className="form-check-input" /> Hide Identity
                      </label>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        }
        { children }
      </Card.Body>
    </Card>
  )
}
